<template>
    <div>
        <h6 style="font-weight: bold">{{ title }}</h6>

        <b-table :items="measures" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" fixed outlined>

            <template v-slot:head(awb)>
                {{ $t('history.label.AWB') }}
            </template>

            <template v-slot:cell(awb)="data">
                {{
                collis.find(c => c.id === data.item.colliID).barcode
                }}
            </template>
            <template v-slot:cell(image)="data">
                <a v-if="data.item.imageUrl != null" :href="data.item.imageUrl">
                    <font-awesome-icon icon="arrow-circle-right" title="click to see image" size="lg"/>
                </a>
            </template>

        </b-table>
    </div>
</template>
<script>
    import localization from '@/mixins/localizationMixin';
    export default {
        components: {},

        mixins: [localization],

        props: {
            title: { type: String, required: true },
            measures: { type: Array, required: true },
            collis: { type: Array, required: true },
        },

        data() {
            return {
                sortBy: 'awb',
                sortDesc: false,
                fields: [
                    { key: ' ', sortable: false },
                    {
                        key: 'weight',
                        sortable: false,
                        formatter: (value) => this.localizedNumber(value),
                    },
                    {
                        key: 'length',
                        sortable: false,
                        formatter: (value) => this.localizedNumber(value),
                    },
                    {
                        key: 'width',
                        sortable: false,
                        formatter: (value) => this.localizedNumber(value),
                    },
                    {
                        key: 'height',
                        sortable: false,
                        formatter: (value) => this.localizedNumber(value),
                    },
                    { key: 'awb', sortable: false },
                  
                    { key: '  ', sortable: false },
                    
                    {
                        key: 'scanTime',
                        sortable: false,
                        formatter: (value) => this.formatDateTimeOffset(value),
                    },
                   
                    
                    { key: 'image', sortable: false },
                ],
            };
        },

        methods: {
        },
    };
</script>

<style></style>
